import { Link } from "react-router-dom";
import TiltedCard from "../../../components/animation/tiltedCard/tiltedCard";
import { Box, Card, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useCallback } from "react";

const SocialMediaDetails = ({
    icon,
    name,
    description,
    link,
    footer
}) => {
    const theme = useTheme();

    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

    const getHeight = useCallback(() => {
        if(isLgUp) return '270px';

        if(isMdUp) return '195px';

        return '180px';
    }, [isLgUp, isMdUp]);

    return (
        <>
            <Link
                to={link}
                style={{
                    textDecoration: 'none'
                }}
                target="_blank"
                data-aos="fade-up"
            >
                <TiltedCard 
                    containerHeight="100%"
                    containerWidth="100%"
                    imageWidth='100%'
                    imageHeight={getHeight()}
                    rotateAmplitude={10}
                    scaleOnHover={0.95}
                    displayOverlayContent={true}
                    overlayContent={
                        <Card
                            elevation={3}
                            sx={{
                                width: '100%',
                                backgroundColor: theme.palette.background.default,
                                borderRadius: 8
                            }}
                        >
                            <Stack
                                direction='column'
                                justifyContent='start'
                                alignItems='center'
                                px={{xs: 1, md: 3}}
                                py={{xs: 3, md: 5}}
                                spacing={1}
                            >
                                <Box
                                    sx={{
                                        width: {xs: 35, md: 50},
                                        pb: {xs: 1, md: 2}
                                    }}
                                >
                                    <img 
                                        src={icon}
                                        alt={name} 
                                        width='100%'
                                    />
                                </Box>

                                <Typography
                                    fontWeight={600}
                                    fontSize={{xs: 12, md: 16, lg: 20}}
                                    textAlign='left'
                                    color={theme.palette.text.primary}
                                    lineHeight={1.5}
                                >
                                    {name}
                                </Typography>

                                <Typography
                                    fontWeight={500}
                                    fontSize={{xs: 10, md: 12}}
                                    textAlign='center'
                                    color={theme.palette.text.secondary}
                                    lineHeight={1.5}
                                    pb={{xs: 1, md: 2}}
                                >
                                    {description}
                                </Typography>

                                <Typography
                                    fontWeight={600}
                                    fontSize={{xs: 10, md: 12}}
                                    textAlign='center'
                                    color={theme.palette.text.primary}
                                    lineHeight={1.5}
                                >
                                    {footer}
                                </Typography>
                            </Stack>
                        </Card>
                    }
                />
            </Link>
        </>
    );
}

export default SocialMediaDetails;